export default class PhotoReviewList {
  constructor(htOptions, oModule) {
    const { welContainer } = htOptions;

    this.nPrevScrollTop = 0; // 이전 스크롤값 저장, 리뷰 상세보기에서 돌아왔을때 해당 스크롤로 복귀
    this.bShowed = false; // 포토 리뷰 리스트가 노출중인지
    this.oModule = oModule;
    this.welContainer = welContainer;
    this.welWin = $(window);
    this.htOptions = htOptions;
    this.setEvent();
  }

  onScroll = () => {
    if (!this.wel || !this.wel.is(':visible')) {
      return;
    }

    const nLastItemTop = this.wel.find('.photo_list_item:last').offset().top;
    const nItemHeight = this.wel.find('.photo_list_item:last').height();
    const nScrollTop = $(window).scrollTop();
    const nViewHeight = $(window).height();

    // 다음 데이터를 불러온다.
    if (nScrollTop + nViewHeight >= nLastItemTop - nItemHeight * 2) {
      this.oModule.getNextData();
    }
  };

  setEvent() {
    this.welWin.on('scroll', this.onScroll);
    // 상세보기
    this.welContainer.on(
      'click',
      'a[data-role=showDetailReview]',
      this.onClickImage
    );
  }

  clearEvent() {
    this.welContainer.off('click', 'a[data-role=showDetailReview]');
  }

  resetData() {
    if (this.wel !== undefined) {
      this.wel.html('');
    }
  }

  addData(aReview) {
    // 포토리스트가 보여지지 않고 있고, 아직 한번도 렌더링이 되지 않았을 경우엔 렌더링을 하지 않는다.
    if (this.wel === undefined && this.bShowed === false) {
      return;
    }

    if (this.wel === undefined) {
      this.init();
    }

    this.renderItem(aReview);
    this.onScroll();
  }

  removeItem(nReviewNo) {
    this.welContainer.find(`[data-reviewNo=${nReviewNo}]`).remove();
  }

  onClickImage = e => {
    if (typeof this.htOptions.onClickPhotoInList === 'function') {
      this.htOptions.onClickPhotoInList();
    }

    const welTarget = $(e.currentTarget);
    TMON.util.setHashJSON({
      photoReview: 'review',
      reviewNo: welTarget.attr('data-reviewNo'),
    });
    this.nPrevScrollTop = $(window).scrollTop();

    return false;
  };

  init() {
    this.wel = this.render(this.welContainer);
    this.renderItem(this.oModule.getData());
  }

  show() {
    this.bShowed = true;
    if (this.wel === undefined) {
      this.init();
    }

    this.wel.show();
    $(window).scrollTop(this.nPrevScrollTop); // 리뷰상세보기에서 돌아왔을 때 스크롤값 복귀
    this.nPrevScrollTop = 0;
    this.onScroll();
  }

  getImageListFromReview(aPhotoReview) {
    const aImages = [];
    aPhotoReview.forEach(htPhotoReview => {
      htPhotoReview.imageInfo.image.forEach(img => {
        aImages.push({
          img,
          reviewNo: htPhotoReview.reviewNo,
          whoCreate: htPhotoReview.whoCreate,
        });
      });
    });
    return aImages;
  }

  hide() {
    if (this.wel) {
      this.wel.hide();
    }

    this.bShowed = false;
  }

  render(welContainer) {
    return welContainer
      .append(
        '<ul data-role="photoList" class="photo_list_wrap" style="display:none"></ul>'
      )
      .find('ul[data-role=photoList]');
  }

  renderItem(aList) {
    const aImageList = this.getImageListFromReview(aList);
    const sHtml = `
                ${aImageList
                  .map(
                    htImage => `
                    <li class="photo_list_item" data-reviewNo="${
                      htImage.reviewNo
                    }">
                        <div class="photo_list_inner">
                            <a href="#" data-role="showDetailReview" data-reviewNo="${
                              htImage.reviewNo
                            }" class="photo_link">
                                <img src="http://storage.tmon.co.kr/thumbs/image?w=300&h=300&url=${encodeURI(
                                  htImage.img
                                )}" title="${
                      htImage.whoCreate
                    } 님의 리뷰 사진입니다." onerror="this.parentNode.className='photo_link error'">
                            </a>
                        </div>
                    </li>
                    `
                  )
                  .join('')}
            `;
    this.wel.append(sHtml);
  }
}
